import type { NavigationGroup, WorkflowStep } from '../models/navigation.model';

/**
 * Single source of truth for the classic workbench navigation.
 * Adding a navigation item is a config change — no template edits required.
 */
export const NAV_GROUPS: NavigationGroup[] = [
  {
    id: 'intake',
    label: 'Intake',
    items: [
      { id: 'ingestion', label: 'Ingestion', icon: 'inbox', route: '/classic/ingestion', keywords: 'upload routing extraction ocr email edi' },
      { id: 'submissions', label: 'Submission Management', icon: 'layers', route: '/classic/submissions', keywords: 'queue cases pipeline new business renewal' },
    ],
  },
  {
    id: 'profile-risk',
    label: 'Profile & Risk',
    items: [
      { id: 'profile', label: 'Customer Risk Profile', icon: 'building', route: '/classic/profile', keywords: 'account customer insured details' },
      { id: 'risk', label: 'Risk Assessment Engine', icon: 'gauge', route: '/classic/risk', keywords: 'score factors benchmark assessment' },
    ],
  },
  {
    id: 'pricing',
    label: 'Pricing',
    items: [
      { id: 'pricing', label: 'Pricing & Rating', icon: 'calculator', route: '/classic/pricing', keywords: 'rate rating premium technical' },
    ],
  },
  {
    id: 'decision',
    label: 'Decision',
    items: [
      { id: 'referrals', label: 'Referral & Approval', icon: 'arrow-up', route: '/classic/referrals', keywords: 'approval chain referral escalate' },
    ],
  },
  {
    id: 'quote-bind',
    label: 'Quote & Bind',
    items: [
      { id: 'quote', label: 'Quote & Policy Integration', icon: 'file-check', route: '/classic/quote', keywords: 'bind policy coverage binder' },
    ],
  },
  {
    id: 'portfolio',
    label: 'Portfolio',
    items: [
      { id: 'portfolio', label: 'Portfolio & Exposure', icon: 'globe', route: '/classic/portfolio', keywords: 'book exposure concentration pml' },
      { id: 'analytics', label: 'Analytics & Dashboards', icon: 'chart', route: '/classic/analytics', keywords: 'dashboards hit ratio scorecard kpi' },
    ],
  },
  {
    id: 'configuration',
    label: 'Configuration',
    gap: true,
    items: [
      { id: 'documents', label: 'Document Management', icon: 'document', route: '/classic/documents', keywords: 'checklist files acord sov loss runs' },
      { id: 'enrichment', label: 'Data Enrichment', icon: 'sparkles', route: '/classic/enrichment', keywords: 'db iso corelogic match profile' },
      { id: 'rules', label: 'Rules & Decision Engine', icon: 'check-circle', route: '/classic/rules', keywords: 'rules engine appetite authority ofac' },
      { id: 'collaboration', label: 'Collaboration Tools', icon: 'chat', route: '/classic/collaboration', keywords: 'notes broker messages tasks' },
      { id: 'compliance', label: 'Compliance & Audit', icon: 'shield', route: '/classic/compliance', keywords: 'audit trail regulatory ofac consent' },
    ],
  },
];

export const WORKFLOW_STEPS: WorkflowStep[] = [
  { key: 'intake', label: 'Intake', navIds: ['ingestion', 'submissions'] },
  { key: 'assess', label: 'Profile & Risk', navIds: ['profile', 'documents', 'enrichment', 'risk'] },
  { key: 'price', label: 'Pricing', navIds: ['pricing'] },
  { key: 'decide', label: 'Decision', navIds: ['rules', 'referrals'] },
  { key: 'execute', label: 'Quote & Bind', navIds: ['quote', 'collaboration'] },
  { key: 'manage', label: 'Portfolio', navIds: ['portfolio', 'analytics', 'compliance'] },
];
